import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/scale.css';
export default function tooltip(node, { allowHTML, animation, appendTo, arrow, content, delay, disabled, duration, hideOnClick, ignoreAttributes, inertia, interactive, maxWidth, moveTransition, offset, placement, theme, trigger, triggerTarget, zIndex }) {
    const tip = tippy(node, {
        allowHTML: allowHTML || false,
        animation,
        appendTo,
        arrow,
        content,
        delay,
        duration,
        hideOnClick,
        ignoreAttributes,
        inertia,
        interactive,
        maxWidth,
        moveTransition,
        offset,
        placement,
        theme,
        trigger,
        triggerTarget,
        zIndex
    });
    if (disabled) {
        tip.disable();
    }
    else {
        tip.enable();
    }
    return {
        // If the props change, let's update the Tippy instance:
        update: (newConfig) => {
            if (newConfig.disabled) {
                tip.disable();
            }
            else {
                tip.enable();
            }
            return tip.setProps({ content, ...newConfig });
        },
        // Clean up the Tippy instance on unmount:
        destroy: () => tip.destroy()
    };
}
